'use strict';
const sortedSubIdeas = require('@mindmup/mapjs-core/src/content/sorted-sub-ideas');
module.exports = function sequenceByLevelLabelGenerator(aggregate, shouldSkipNodeLabel) {
	const result = {},
		isGroup = function (idea) {
			return idea && idea.attr && idea.attr.group;
		},
		traverseNonGroups = function (contentIdea, iterator, level) {
			const isSingleRootMap = !level && (!contentIdea.formatVersion || contentIdea.formatVersion < 3);
			let subLevel;
			level = level || (isSingleRootMap ? 1 : 0);
			if (!isGroup(contentIdea) && (isSingleRootMap || level)) {
				iterator(contentIdea, level);
			}
			sortedSubIdeas(contentIdea).forEach(function (subIdea) {
				subLevel = isGroup(subIdea) ? level : level + 1;
				traverseNonGroups(subIdea, iterator, subLevel);
			});
		},
		currentLevelMax = [],
		labelNodes = function (idea, level) {
			if (shouldSkipNodeLabel && shouldSkipNodeLabel(idea)) {
				return;
			}
			const label = (currentLevelMax[level] || 0) + 1;
			currentLevelMax[level] = label;
			result[idea.id] =  String(level) + '.' + label;
		};
	traverseNonGroups(aggregate, labelNodes);
	return result;
};
